import axios from 'axios';
import { LocalStorage as SessionStorage } from 'quasar';

export default ({ Vue, router }) => {
  axios.defaults.baseURL = process.env.API_URL;

  axios.interceptors.request.use(config => {
    const token = getTokenFromSessionStorage();

    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }

    return config;
  });

  axios.interceptors.response.use(
    response => response,
    error => handleErrorResponse(error, router),
  );

  Vue.prototype.$axios = axios;
};

function getTokenFromSessionStorage() {
  const token = SessionStorage.getItem('token');
  return token && JSON.parse(token);
}

function handleErrorResponse(error, router) {
  if (error.response.status === 401) {
    SessionStorage.remove('token');
    router.push({ path: '/' });
  } else {
    return Promise.reject(error);
  }
}
